<div class="agent-body h-100 d-flex flex-column justify-content-between m-3">
  <div class="d-flex flex-row justify-content-between">
    <div class="button-list">
      <button class="agent-btn btn-accello-secondary" (click)="openGenericModal(false)">
        <img [src]="'images/virtusa-icons/add-icon-dark.svg' | assetUrl" alt="Add Icon" width="18" height="18" />
        Add New Device
      </button>

      <button class="agent-btn btn-accello-light" (click)="openDeleteConfirmationModal()"
        [disabled]="selectedDeviceList.length === 0" (focus)="changeRemoveIcon(false)"
        (mouseenter)="changeRemoveIcon(false)" (mouseleave)="changeRemoveIcon(false)" (blur)="changeRemoveIcon(false)"
        (mousedown)="changeRemoveIcon(true)" (mouseup)="changeRemoveIcon(false)">
        <img [src]="iconSrcDelete | assetUrl" alt="Reclaim Execution Engine" width="18" height="18" />
        Remove Devices
      </button>
    </div>
  </div>

  <app-loading *ngIf="isLoading" [text]="'Loading'" class="h-100"></app-loading>
  <div class="table-div h-100" *ngIf="!isLoading">
    <app-expandable-table [columns]="columns" [data]="devices" [options]="options"
      (handleActions)="handleActionsInTable($event)" (onRowSelect)="handleRowSelect($event)"></app-expandable-table>
  </div>
</div>